<template>
    <div class="m-progress" :style="`width:${width}px;`">
        <div style="text-align: center;vertical-align: middle;">
            <div class="m-progress-outer" style="display:inline-block;width:80%;">
                <div class="m-progress-inner">
                    <div :class="['u-progress-bg', {'u-success-bg': progress >= 100}]" 
                      :style="`width: ${progress >= 100 ? 100:progress}%; height: ${strokeWidth}px;`">
                    </div>
                </div>
            </div>
            <div style="display: inline-block;width: 20%;vertical-align: middle;text-align: center;">
                <svg class="u-success" v-if="progress>=100" viewBox="64 64 896 896" data-icon="check-circle" aria-hidden="true" focusable="false" style="margin: auto;">
                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path>
                </svg>
            </div>
        </div>
        <div class="u-progress-text" style="width:80%">{{ progress>=100 ? 100:progress }}%</div>
    </div>
</template>

<script>
  export default {
    name: 'ProgressBar',
    props: {
      width: { // 进度条总宽度
        type: Number,
        default: 600
      },
      progress: { // 当前进度
        type: Number,
        required:true
        // default: 36
      },
      strokeWidth: { // 进度条线的宽度
        type: Number,
        default: 8
      },
      showInfo: { // 是否显示进度数值或状态图标
        type: Boolean,
        default: true
      }
    }
  }
</script>
  
<style lang="less" scoped>
.m-progress {
  margin: 0 px auto;
  display: flex;
  vertical-align: middle;
  .m-progress-outer {
    width: 70%;
    display: inline-block;
    .m-progress-inner {
      width: 100%;
      background: #c3c8c5;
      border-radius: 100px;
      .u-progress-bg {
        background: linear-gradient(to right, rgb(0, 73, 200), rgb(0, 73, 200));
        border-radius: 100px;
        transition: all .3s cubic-bezier(.08,.82,.17,1);
      }
      .u-success-bg {
        background: rgb(0, 73, 200);
      }
    }
  }
  .u-success {
    width: 14px;
    height: 14px;
    fill: rgb(0, 73, 200);
    margin-left: 10px;
    margin-bottom: auto;
  }
  .u-progress-text {
    font-size: 12px;
    margin-left: 8px;
    color: rgba(0,0,0,.45);
  }
}
</style>